import { createFileRoute } from "@tanstack/react-router";

import { NewGroupForm } from "../components/group/new-group-form";

/** A group of lists: one link for several lists, any circle, any occasion. */
export const Route = createFileRoute("/groupes/nouveau")({
  component: () => <NewGroupForm kind="lists" />,
});
